import { isNullOrUndefinedOrEmpty } from "../filter-value";

// Mirrors the Add New Loan Step 10 rules in create-loan-fee/index.jsx validateFeeSection.
// `context` carries the Encompass values that decide which fields apply:
//   isCbWhs          — loan channel is CB or WHS
//   compensationPlan — LCP.X1 ("Borrower Paid" requires BPC)
//   occupancy        — 1811 ("Investor" requires the business-purpose answers)
//   hasCoBorrower    — 4004 co-borrower name exists (requires co-borrower POA)

const REQUIRED_MESSAGE =
	"Please provide a value for all fields highlighted above.";

// M/D/YYYY or M-D-YYYY (1–2 digit month/day) → UTC-midnight Date, or null when it is not a
// real calendar date. The save uses the same parse, so a date that passes is always saved.
export const parseClosingDate = (value) => {
	const match = /^(\d{1,2})[/-](\d{1,2})[/-](\d{4})$/.exec(String(value || "").trim());
	if (!match) return null;
	const [month, day, year] = [Number(match[1]), Number(match[2]), Number(match[3])];
	const date = new Date(Date.UTC(year, month - 1, day));
	const real = date.getUTCMonth() === month - 1 && date.getUTCDate() === day;
	return real ? date : null;
};

export const getDashboardClosingFieldErrors = (closing, context = {}) => {
	const errors = new Set();
	const data = closing || {};
	const { isCbWhs, compensationPlan, occupancy, hasCoBorrower } = context || {};

	if (isCbWhs && isNullOrUndefinedOrEmpty(data.closingDate)) errors.add("closing.closingDate");
	// A typed date that isn't a real date would otherwise be skipped by the save silently.
	["closingDate", "purchaseContractDate"].forEach((key) => {
		if (!isNullOrUndefinedOrEmpty(data[key]) && !parseClosingDate(data[key])) {
			errors.add(`closing.${key}`);
		}
	});
	if (isNullOrUndefinedOrEmpty(data.vestingType)) errors.add("closing.vestingType");
	if (isNullOrUndefinedOrEmpty(data.poaBorrower)) errors.add("closing.poaBorrower");

	if (hasCoBorrower && isNullOrUndefinedOrEmpty(data.poaCoBorrower)) {
		errors.add("closing.poaCoBorrower");
	}

	if (isCbWhs && compensationPlan === "Borrower Paid") {
		if (isNullOrUndefinedOrEmpty(data.bpcPercent)) errors.add("closing.bpcPercent");
		if (isNullOrUndefinedOrEmpty(data.bpcDollars)) errors.add("closing.bpcDollars");
	}

	if (occupancy === "Investor") {
		if (isNullOrUndefinedOrEmpty(data.cashOutBusinessPurpose)) {
			errors.add("closing.cashOutBusinessPurpose");
		}
		if (isNullOrUndefinedOrEmpty(data.occupiedByFamily)) errors.add("closing.occupiedByFamily");
	}

	return errors;
};

export const validateDashboardClosing = (closing, context, setError) => {
	const errors = getDashboardClosingFieldErrors(closing, context);
	if (errors.size > 0) {
		setError(REQUIRED_MESSAGE);
		return false;
	}
	return true;
};
